import { Boton, Spinner } from 'asocomponents'
import React, { useEffect, useState } from 'react'
import { WEBURLEGALES } from '../../../helpers/frontend'
import { useDispatch, useSelector } from 'react-redux'
import { formatearNumero } from '../../../helpers/funciones'
import { formatearFechaLuxon } from '../../../../modules/utils/formatearFecha'
import { setPagoSinFactura } from '../../../redux/datosPagoSinFacturaSlice'
import { useMostrarMensajeConfirmacion } from "../../../helpers/mensajeria"
import ModalAgregarPago from './ModalAgregarPago'
import { MENSAJESAPP } from "../../../const/constantes.js";

export default function GrillaDetallePagos({idLiquidacionWebSinFactura}) {
    const dispatch = useDispatch()
    const pagosSinFactura = useSelector(state => state.rootReducer.datosPagoSinFactura.pagoSinFactura);
    const pagosLiq = useSelector(state => state.rootReducer.datosPagoSinFactura.pagoSinFactura.pagos);
    const mostrarMensajeConfirmacion = useMostrarMensajeConfirmacion()

    //#region const  
    const [isLoading, setIsLoading] = useState(false)
    const [resultado, setResultado] = useState([])
    const [existenRdos, setExistenRdos] = useState(true)
    const [modalOpen, setModalOpen] = useState(false);
    const [idKeyPago,setIdKeyPago] = useState()

    //PARA EL PAGINADO
    const [paginaActual, setPaginaActual] = useState(1)
    const [elementosPorPagina] = useState(10) // Cambia esto según cuántos elementos quieres mostrar por página

    //Estado para el menu desplegable de opciones sobre la grilla
    const [showMenuIndex, setShowMenuIndex] = useState(null) // Estado para almacenar el índice de la fila en la que se muestra el menú

    //#region paginado y fetchData
    const indiceUltimoElemento = paginaActual * elementosPorPagina
    const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina
    let totalPaginas = resultado === null ? 1 : Math.ceil(resultado.length / elementosPorPagina)

    const elementosPaginados =
        resultado === null
            ? []
            : resultado.slice(indicePrimerElemento, indiceUltimoElemento)

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina)
    }

    const confirmarEliminarPago = (id) => {
        const pagosNew = resultado.filter(c => c.idKey !== id)
        dispatch(setPagoSinFactura({
            ...pagosSinFactura,
            pagos: pagosNew
        }))
        setResultado(pagosNew)
    }

    const eliminarPago = (id) => {
        mostrarMensajeConfirmacion(MENSAJESAPP.CONFIRMACION.ELIMINARPAGO, () => confirmarEliminarPago(id), "question")
    };
    //#endregion

    useEffect(() => {
        setResultado(pagosLiq)
    }, [pagosLiq])

    if (isLoading) {
        return <Spinner color="red" size="50" />
    }

    return (
        <div className="overflow-hidden">
            <div className="shadow-md sm:rounded-lg mr-2 ml-2">
                <table className="table-fixed text-xs text-left rtl:text-right text-gray-500 w-[100%] ">
                    <thead className="text-[0.6rem] text-gray-700 uppercase bg-gray-200">
                        <tr>
                            <th scope="col" className="text-center  py-1" style={{ width: "10%" }}>
                                Fecha Vto
                            </th>
                            <th scope="col" className="text-center  py-1" style={{ width: "30%" }}>
                                Forma de Pago
                            </th>
                            <th scope="col" className="text-center  py-1" style={{ width: "15%" }}>
                                Total
                            </th>
                            <th scope="col" className="text-center  py-1" style={{ width: "7%" }}>
                            </th>
                            <th scope="col" className="text-center  py-1" style={{ width: "7%" }}>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {elementosPaginados &&
                            elementosPaginados.map((item, index) => (
                                <tr
                                    className="bg-white border-b hover:bg-gray-50 text-xs font-normal"
                                    key={item.idKey}
                                >
                                    <td className="text-center">{formatearFechaLuxon(item.fechaVto, "dd/MM/yyyy")}</td>
                                    <td className="text-left">{item.formaPago.forma.label} {item.formaPago.subforma && " - " + item.formaPago.subforma.label}</td>
                                    <td className="text-center">$ {formatearNumero(String(item.importeTotal))}</td>
                                    <td className="text-center">
                                        <Boton type="button" icono="eye" width="w-2" alt="Ver Detalle Pago" onClick={() => {
                                            setIdKeyPago(item.idKey)
                                            setModalOpen(true)
                                            }}/>
                                    </td>
                                    <td className="text-center">
                                        {!idLiquidacionWebSinFactura &&<Boton type="button" icono="eliminar" width="w-2" onClick={() => eliminarPago(item.idKey)} alt="Eliminar Pago"/>}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            <ModalAgregarPago isOpen={modalOpen} onClose={() => setModalOpen(false)} idKey={idKeyPago}/>
            {!existenRdos &&
                <div className="flex flex-row items-center justify-center h-full">
                    <div className="font-semibold text-lg text-center mb-4">
                        No encontramos ningún registro para tu búsqueda
                    </div>
                    <div className="w-[300px] flex justify-center ml-40">
                        <img src={`${WEBURLEGALES}/images/papers.svg`} alt="Sin resultados" />
                    </div>
                </div>
            }
            <div className="col-span-2 flex justify-end items-center m-2">
                <span className="text-sm m-1">
                    Página {paginaActual} de {totalPaginas === 0 ? 1 : totalPaginas}
                </span>
                <button
                    className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
                    onClick={() => cambiarPagina(paginaActual - 1)}
                    disabled={paginaActual === 1}
                >
                    {"<"}
                </button>
                <button
                    className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
                    onClick={() => cambiarPagina(paginaActual + 1)}
                    disabled={resultado ? indiceUltimoElemento >= resultado.length : true}
                >
                    {">"}
                </button>
            </div>
        </div>
    )
}
